/**
 * Sizes used for `Text` component sizing.
 */
export enum Sizes {
    XS = 'XS',
    S = 'S',
    M = 'M',
    L = 'L',
    XL = 'XL',
}
